<template>
    <div>
        <h1>{{ currentGate.name }} Gate</h1>
        <p>{{ currentGate.description }}</p>
    </div>
</template>

<script>
import Gate2dData from '../mixins/gates-2d-data'
import {bus} from "@/main";

export default {
  name: "Gate2dData",
  mixins: [
    Gate2dData
  ],
  props: {
    gateName: String,
    trackCount: Number,
  },
  data() {
    return {
      visible: {
        type: Boolean,
        default: true
      },
      currentGate: null,
      audioTracks: [],
    }
  },
  methods: {

    extractMetadata() {
      this.currentGate = this.gates2dData.find(gatesData => {
        return gatesData.name === this.gateName
      });

    },

    assignAudio() {
      for (let i = 0; i < this.trackCount; i++) {
        this.audioTracks.push(this.currentGate.audio[i])
      }

      bus.$emit("postAudio", this.audioTracks)

    },
  },

  created() {
    this.extractMetadata()
  },

  mounted(){
    this.assignAudio()
  }
}

</script>

<style scoped>

</style>
